// import Item from "antd/lib/list/Item";
// import { useAgencyInfo } from "context/agency";
// import { useAppServices } from "hook/services";
// import React from "react";
import { useEffect, useState } from "react";
// import { useState } from "react";
import crypto from "crypto-js";
import env from "config";
// import 'crypto-js/addon/pad-iso10126';
// import 'crypto-js/enc-utf8';

const SsoHandler = () => {
  const [ssodata, setssodata] = useState("");
  const decript_data = async (payload, app) => {
    let ciphertext = await crypto.AES.decrypt(payload, app.key).toString(crypto.enc.Utf8);
    console.log(ciphertext);
    setssodata(ciphertext);
  };
  const checkSSO = () => {
    const key = new Promise((resolve) => {
      const sso = {
        app_id: "67bf112b10332b528011dcec",
        key: env.SSO_key,
      };

      
      //   "U2FsdGVkX19n+Ou6vvlswvN+CoQEqPYwUIFH/35kzTlZ7OOYiTXs3BYph5lmVbO0ev2/KLOlU6tLSVOnh/d/Y3uviNVAMT/u8r0UdJi6lojcg4pskYb99lJGR306Rk9ifoYNJMXVls4LTaFG8tBA7DXupqc8rsUTbMVAXSQMUUv1WyaIOJQ0D9avc4qHkLhvPEIMj83lhH7BFwGMka6imHYTFbwgqt5llj6oFOo5aDqTRnKZh69LiFWrCOaCSnhZTT2ygGQK2H1ZWoNSnTxGXGfLrB/GHZ/Gj3ceVjSe4MU=",
      //   sso
      // );

      window.parent.postMessage({ message: "REQUEST_USER_DATA" }, "*");
      const temp = window.addEventListener("message", ({ data }) => {
        if (data.message === "REQUEST_USER_DATA_RESPONSE") {
          console.log(data.payload, sso, "sso");
          decript_data(data.payload, sso);
        } else {
        }
        // console.log(temp, 'temptemptemptemptemptemp')
      });
    });
  };
  return {
    SSO: ssodata,
    checkSSO: checkSSO,
  };
};
export default SsoHandler;
